if (dvApp.boot.lang === "ar") {
    $.extend(
        dvApp.boot.__messages, {
            "Portal": "البوابة",
            "Entity Name": "اسم الجهة",
            "Account Type": "نوع الحساب",
            "First Level": "المستوى الأول",
            "Entity Of Technical Supervision": "جهة الإشراف الفني",
            "Amended From": "معدل من",
            "Entity Type": "نوع الجهة ",
            "Entity Classification": "تصنيف الجهة ",
            "Second Level": "المستوى الثاني",
            "Entity Issuing License": "جهة إصدار الرخصة",
            "Province": "المقاطعة",
            "Geographical Area": "المنطقة الجغرافية",
            "License No": "رقم الرخصة",
            "License End Date": "تاريخ انتهاء الرخصة",
            "Phone": "الهاتف",
            "License Date": "تاريخ الرخصة",
            "The Target Audience": "الفئة المستهدفة",
            "Email": "البريد الإلكتروني",
            "Entity Manager Name": "اسم مدير الجهة ",
            "Data Entry Operator Name": "اسم مدخل البيانات",
            "Data Entry Operator Email": "بريد مدخل البيانات الإلكتروني",
            "Entity Manager Phone": "هاتف مدير الجهة ",
            "Data Entry Operator Phone": "هاتف مدخل البيانات",
            "Address": "العنوان",
            "Number of Employees": "عدد الموظفين",
            "Does the Entity have Endowments or Sustainability": "هل لدى الجهة  أوقاف أو استدامة",
            "Has There been a Previous Partnership with the Organization": "هل كانت هناك شراكة سابقة مع المنظمة",
            "Does Entity has a Partnership with Government Entities": "هل لدى الجهة  شراكة مع الجهات الحكومية",
            "Entity Degree in Governance": "درجة الجهة  في الحوكمة",
            "Does Entity have Volunteers": "هل لدى الجهة  متطوعين",
            "Does Entity have Partnerships with Donor": "هل لدى الجهة  شراكات مع الجهات المانحة",
            "Bank Name": "اسم البنك",
            "Bank": "البنك",
            "Project Study": "دراسة المشروع",
            "IBAN": "رقم الآيبان",
            "Bank Account Name": "اسم الحساب البنكي",
            "License": "الرخصة",
            "Other": "أخرى",
            "Attachment": "المرفقات",
            "Attachments": "المرفقات",
            "Government Report": "التقرير الحكومي",
            "Legal Accountant Report": "تقرير المحاسب القانوني",
            "Bank Account": "الحساب البنكي",
            "Filters applied for {0}": "تم تطبيق التصفية على {0}",
            "Latitude": "خط العرض",
            "Longitude": "خط الطول",
            "Error": "خطأ",
            "User email already exists.": "البريد الإلكتروني للمستخدم موجود بالفعل.",
            "User phone already exists.": "رقم هاتف المستخدم موجود بالفعل.",
            "Invalid your email.": "بريدك الإلكتروني غير صالح.",
            "Target Audience Category": "الفئة المستهدفة",
            "Dashboard": "الصفحة الرئيسية",
            "Project Support Request": "طلب دعم مشروع",
            "All Projects": "كافة المشاريع",
            "Complete Project Data": "استكمال بيانات المشروع",
            "Edit Data": " تعديل البيانات",
            "Change Password": "تغيير كلمة المرور",
            "Edit Entity Data": "تعديل بيانات الجهة",
            "Registration Under Review": "التسجيل قيد المراجعة",
            "Thank you for registering. The data will be reviewed within (1 - 3) business days, and you will receive a notification on your email once the registration is approved.": "شكرًا لتسجيلكم. ستتم مراجعة البيانات خلال (1 – 3) أيام عمل، وسيصلكم إشعار على بريدكم الإلكتروني فور اعتماد التسجيل.",
            "Log Out": "تسجيل خروج",
            "Statistics": "إحصائيات",
            "Welcome": "مرحبا",
            "Your support amounts total": "إجمالي مبالغ الدعم الخاص بك",
            "SAR": "ريال سعودي",
            "Number of Projects": "عدد المشاريع",
            "Supported Projects": "مشاريع مدعومة",
            "Supported": "مدعومة",
            "Not Supported": "غير مدعومة",
            "Projects Not Allowed": "مشاريع معتذر عنها",
            "Average Project Rating": "متوسط تقييم المشاريع",
            "Entity Status": "حالة الجهة",
            "Rejected": "مرفوضة",
            "Percentage of Supported": "نسبة المشاريع المدعومة",
            "COPYRIGHT": "جميع الحقوق محفوظة",
            "Powered By": "تطوير",
            "Project No.": "رقم المشروع",
            "Project Name": "اسم المشروع",
            "Area": "المنطقة",
            "Status": "الحالة",
            "Evaluation": "التقييم",
            "Clear Cache": "مسح الكاش",
            "Create New": "إنشاء جديد",
            "Welcome Back!": "مرحبًا بعودتك!",
            "Please sign in to your account and start your work": "الرجاء تسجيل الدخول إلى حسابك وبدء عملك",
            "Entity status must be approved": "يجب ان تكون حالة الجمعية مقبولة",
            "No {0} Found": " لم يتم العثور على {0} ",
            "Password must be equal or greater than 6 char": "يجب أن تكون كلمة المرور مساوية أو أكبر من 6 أحرف",
            "Confirm password didn't match": "تأكيد كلمة المرور غير متطابقة",
            "Loading...": "جاري تحميل...",
            "Response Grants": "إضافة مشروع",
            "Innovative Grants": "منح ابتكاري",
            "Updated Entities": "جهات محدثة",
            "Details": "التفاصيل",
            "Confirm": "تأكيد",
            "Yes": "نعم",
            "No": "لا",
            "Rows": "صفوف",
            "Showing": "عرض",
            "of": "من",
            "Document has been created": "تم إنشاء المستند",
            "Document has been updated": "تم تحديث المستند",
            "Request Review Data": "طلب استكمال بيانات",
            "Will change status of entity to {0}?": "سيتم تغيير حالة الكيان إلى {0}؟",
        });
}
